import {
  parse as fnsParse,
  format,
  isValid,
  isBefore,
  addMonths,
  parseISO,
  subDays,
} from 'date-fns'
import { enUS } from 'date-fns/locale'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import { datetime } from '~/shared/config'
import { DayEnum, TimezoneCode } from '~/shared/config/enums'

export { addMonths, format as formatDate }

export const fromString = (input: string) =>
  fnsParse(input, datetime.apiDateFormat, new Date())

export const fromDatetimeString = (input: string) => parseISO(input)

export const isValidDateString = (input: string) => isValid(fromString(input))

export const formatDateForApi = (date: Date) =>
  format(date, datetime.apiDateFormat)

export const formatDateTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateTimeFormat)

export const formatDateForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiDateFormat)

export const formatTimeForUI = (input: string) =>
  format(fromDatetimeString(input), datetime.uiTimeFormat)

export const isBeforeNow = (date: Date | number) => isBefore(date, new Date())

export const formatDateApiToLocalDateTimeForUi = (
  apiDate: string | Date,
  timezone: TimezoneCode,
) => {
  const utcDate = zonedTimeToUtc(apiDate, timezone)
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const localDateTime = utcToZonedTime(utcDate, userTimezone)
  return format(localDateTime, 'yyyy-MM-dd HH:mm:ss')
}

export const getDay = (day: 'current' | 'yesterday'): DayEnum => {
  const yesterday = subDays(new Date(), day === 'current' ? 0 : 1)
  const dayName = format(yesterday, 'EEEE', { locale: enUS })

  return DayEnum[dayName as keyof typeof DayEnum]
}
